:host {
  display: block;
}

@tailwind base;
@tailwind components;
@tailwind utilities;

.spinner {
  animation: rotate 2s linear infinite;
  z-index: 2;
  top: 50%;
  left: 50%;
}

.spinner .path {
  stroke: rgb(59,130,246);
  stroke: rgb(59, 130, 246);
  stroke-linecap: round;
  animation: dash 3.0s ease-in-out infinite;
  stroke-dasharray: 210, 240;
  stroke-dashoffset: 120;
}

@keyframes rotate {
  100% {
    transform: rotate(360deg);
  }
}
@keyframes dash {
  0% {
    stroke-dasharray: 1, 150;
    stroke-dashoffset: 0;
  }
  50% {
    stroke-dasharray: 90, 150;
    stroke-dashoffset: -35;
  }
  100% {
    stroke-dasharray: 90, 150;
    stroke-dashoffset: -124;
  }
}

.iconDark{fill:#E2E8F0;}

.iconLight{fill:#1E293B;}

.main-container {
}

.hidden-container {
  display: none;
}

.main-container:hover .hidden-container {
  display: block;
}
